/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Meta_TitleInputs */

const en_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sign in | Mark Egly Golf`)
};

const es_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iniciar sesión | Mark Egly Golf`)
};

const de_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Anmelden | Mark Egly Golf`)
};

const zh_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`登录 | Mark Egly Golf`)
};

const ar_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تسجيل الدخول | Mark Egly Golf`)
};

const fr_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Connexion | Mark Egly Golf`)
};

const vi_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đăng nhập | Mark Egly Golf`)
};

const sw_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingia | Mark Egly Golf`)
};

const th_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เข้าสู่ระบบ | Mark Egly Golf`)
};

const bs_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prijava | Mark Egly Golf`)
};

const ja_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`サインイン | Mark Egly Golf`)
};

const ko_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`로그인 | Mark Egly Golf`)
};

const pt_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrar | Mark Egly Golf`)
};

const it_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accedi | Mark Egly Golf`)
};

const sv_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logga in | Mark Egly Golf`)
};

const nl_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inloggen | Mark Egly Golf`)
};

const da_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log ind | Mark Egly Golf`)
};

const nb_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logg inn | Mark Egly Golf`)
};

const fi_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirjaudu sisään | Mark Egly Golf`)
};

const pl_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zaloguj się | Mark Egly Golf`)
};

const ru_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Вход | Mark Egly Golf`)
};

const tr_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giriş yap | Mark Egly Golf`)
};

const hi_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`साइन इन | Mark Egly Golf`)
};

const id_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Masuk | Mark Egly Golf`)
};

const ms_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Log masuk | Mark Egly Golf`)
};

const cs_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přihlášení | Mark Egly Golf`)
};

const el_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Σύνδεση | Mark Egly Golf`)
};

const he_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`התחברות | Mark Egly Golf`)
};

const af_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meld aan | Mark Egly Golf`)
};

const hu_auth_meta_title = /** @type {(inputs: Auth_Meta_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bejelentkezés | Mark Egly Golf`)
};

/**
* | output |
* | --- |
* | "Sign in \| Mark Egly Golf" |
*
* @param {Auth_Meta_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const auth_meta_title = /** @type {((inputs?: Auth_Meta_TitleInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Meta_TitleInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_meta_title(inputs)
	if (locale === "de") return de_auth_meta_title(inputs)
	if (locale === "zh") return zh_auth_meta_title(inputs)
	if (locale === "ar") return ar_auth_meta_title(inputs)
	if (locale === "fr") return fr_auth_meta_title(inputs)
	if (locale === "vi") return vi_auth_meta_title(inputs)
	if (locale === "sw") return sw_auth_meta_title(inputs)
	if (locale === "th") return th_auth_meta_title(inputs)
	if (locale === "bs") return bs_auth_meta_title(inputs)
	if (locale === "ja") return ja_auth_meta_title(inputs)
	if (locale === "ko") return ko_auth_meta_title(inputs)
	if (locale === "pt") return pt_auth_meta_title(inputs)
	if (locale === "it") return it_auth_meta_title(inputs)
	if (locale === "sv") return sv_auth_meta_title(inputs)
	if (locale === "nl") return nl_auth_meta_title(inputs)
	if (locale === "da") return da_auth_meta_title(inputs)
	if (locale === "nb") return nb_auth_meta_title(inputs)
	if (locale === "fi") return fi_auth_meta_title(inputs)
	if (locale === "pl") return pl_auth_meta_title(inputs)
	if (locale === "ru") return ru_auth_meta_title(inputs)
	if (locale === "tr") return tr_auth_meta_title(inputs)
	if (locale === "hi") return hi_auth_meta_title(inputs)
	if (locale === "id") return id_auth_meta_title(inputs)
	if (locale === "ms") return ms_auth_meta_title(inputs)
	if (locale === "cs") return cs_auth_meta_title(inputs)
	if (locale === "el") return el_auth_meta_title(inputs)
	if (locale === "he") return he_auth_meta_title(inputs)
	if (locale === "af") return af_auth_meta_title(inputs)
	if (locale === "hu") return hu_auth_meta_title(inputs)
	return en_auth_meta_title(inputs)
});